import { Navigate } from 'react-router-dom';
import { routes } from '@/lib/routes';

/** Legacy /app/audit route → Owner10 decisions/audit hub */
const AuditPage = () => <Navigate to={`${routes.owner}/decisions`} replace />;

export default AuditPage;
